// extracted by mini-css-extract-plugin
export default {"zoomModal":"B0-z"};